import { render, staticRenderFns } from "./ModalCompartilhar.vue?vue&type=template&id=f1b2f88a&scoped=true"
import script from "./ModalCompartilhar.vue?vue&type=script&lang=js"
export * from "./ModalCompartilhar.vue?vue&type=script&lang=js"
import style0 from "./ModalCompartilhar.vue?vue&type=style&index=0&id=f1b2f88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b2f88a",
  null
  
)

export default component.exports